let lastDismissAt = 0;

export const markWidgetDismissed = () => {
  lastDismissAt = performance.now();
};

export const shouldBlockOpen = (cooldownMs = 250) => {
  return performance.now() - lastDismissAt < cooldownMs;
};
